// extracted by mini-css-extract-plugin
module.exports = {"header":"_266FS2G4EiPtgndh7Urkg5","logo":"_1bRFFqeFseQOi_oHO9FBnt"};